import { render, staticRenderFns } from "./resource-types.vue?vue&type=template&id=4f4c17bd"
import script from "./resource-types.vue?vue&type=script&lang=js"
export * from "./resource-types.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports